import styled from 'styled-components';

const EmailLink = styled.a`
    text-decoration: ${props => props.textDecoration || "none"};
    color: ${props => props.color || "white"};
`;

export default EmailLink;